"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modes = exports.NotEnoughNftOwned = exports.NotOwnedNft = void 0;
const eip55_1 = __importDefault(require("eip55"));
const ethereumjs_abi_1 = __importDefault(require("ethereumjs-abi"));
const invariant_1 = __importDefault(require("invariant"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const errors_1 = require("@ledgerhq/errors");
const erc721_1 = require("./erc721");
exports.NotOwnedNft = (0, errors_1.createCustomErrorClass)("NotOwnedNft");
exports.NotEnoughNftOwned = (0, errors_1.createCustomErrorClass)("NotEnoughNftOwned");
const NotTokenIdsProvided = (0, errors_1.createCustomErrorClass)("NotTokenIdsProvided");
const QuantityNeedsToBePositive = (0, errors_1.createCustomErrorClass)("QuantityNeedsToBePositive");
const erc1155Transfer = {
    /**
     * Tx data is filled during the buildEthereumTx
     */
    fillTransactionData(a, t, tx) {
        const data = serializeTransactionData(a, t);
        (0, invariant_1.default)(data, "serializeTransactionData provided no data");
        tx.data = "0x" + data.toString("hex");
        tx.to = t.collection;
        tx.value = "0x00";
    },
    /**
     * Tx status is filled after the buildEthereumTx
     */
    fillTransactionStatus: (a, t, result) => {
        var _a, _b;
        if (!result.errors.recipient) {
            result.totalSpent = result.estimatedFees;
            result.amount = new bignumber_js_1.default(t.amount);
            if (result.estimatedFees.gt(a.spendableBalance)) {
                result.errors.amount = new errors_1.NotEnoughBalanceInParentAccount();
            }
            (_a = t.quantities) === null || _a === void 0 ? void 0 : _a.forEach(quantity => {
                if (!quantity || quantity.isLessThan(1)) {
                    result.errors.amount = new QuantityNeedsToBePositive();
                }
            });
            const enoughTokensOwned = ((_b = t.tokenIds) === null || _b === void 0 ? void 0 : _b.reduce((acc, tokenId, index) => {
                var _a, _b;
                if (acc instanceof Error) {
                    return acc;
                }
                const nft = (_a = a.nfts) === null || _a === void 0 ? void 0 : _a.find(n => n.tokenId === tokenId);
                const transferQuantity = Number((_b = t.quantities) === null || _b === void 0 ? void 0 : _b[index]);
                if (!nft) {
                    return new exports.NotOwnedNft();
                }
                if (transferQuantity && !nft.amount.gte(transferQuantity)) {
                    return new exports.NotEnoughNftOwned();
                }
                return true;
            }, true)) || new NotTokenIdsProvided();
            if (!enoughTokensOwned || enoughTokensOwned instanceof Error) {
                result.errors.amount = enoughTokensOwned;
            }
        }
    },
    /**
     * This will only be used by LLM & LLD, not the HW.
     */
    fillDeviceTransactionConfig(input, fields) {
        var _a, _b, _c, _d, _e, _f, _g;
        fields.push({
            type: "text",
            label: "Type",
            value: `NFT Transfer`,
        });
        fields.push({
            type: "text",
            label: "To",
            value: (_a = input.transaction.recipient) !== null && _a !== void 0 ? _a : "",
        });
        fields.push({
            type: "text",
            label: "Collection Name",
            value: input.transaction.collectionName || "",
        });
        fields.push({
            type: "text",
            label: "Quantity",
            value: (_d = (_c = (_b = input.transaction.quantities) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.toFixed()) !== null && _d !== void 0 ? _d : "",
        });
        fields.push({
            type: "address",
            label: "NFT Address",
            address: (_e = input.transaction.collection) !== null && _e !== void 0 ? _e : "",
        });
        fields.push({
            type: "text",
            label: "NFT ID",
            value: (_g = (_f = input.transaction.tokenIds) === null || _f === void 0 ? void 0 : _f[0]) !== null && _g !== void 0 ? _g : "",
        });
    },
    /**
     * Optimistic Operation is filled post signing
     */
    fillOptimisticOperation(a, t, op) {
        var _a;
        op.type = "FEES";
        op.nftOperations = (_a = t.tokenIds) === null || _a === void 0 ? void 0 : _a.map((tokenId, i) => {
            var _a, _b;
            return (Object.assign(Object.assign({}, op), { id: "", type: "NFT_OUT", senders: [eip55_1.default.encode(a.freshAddress)], recipients: [eip55_1.default.encode(t.recipient)], standard: "ERC1155", contract: eip55_1.default.encode((_a = t.collection) !== null && _a !== void 0 ? _a : ""), tokenId, value: ((_b = t.quantities) === null || _b === void 0 ? void 0 : _b[i]) || new bignumber_js_1.default(0) }));
        });
    },
    prepareTransaction: erc721_1.prepareTransaction,
    getResolutionConfig: () => ({ nft: true }),
};
function serializeTransactionData(account, transaction) {
    var _a;
    const from = eip55_1.default.encode(account.freshAddress);
    const to = eip55_1.default.encode(transaction.recipient);
    const tokenIds = transaction.tokenIds || [];
    const quantities = ((_a = transaction.quantities) === null || _a === void 0 ? void 0 : _a.map(q => ((q === null || q === void 0 ? void 0 : q.isFinite()) ? q === null || q === void 0 ? void 0 : q.toFixed() : "0"))) || [];
    return (tokenIds === null || tokenIds === void 0 ? void 0 : tokenIds.length) > 1
        ? ethereumjs_abi_1.default.simpleEncode("safeBatchTransferFrom(address,address,uint256[],uint256[],bytes)", from, to, tokenIds, quantities, "0x00")
        : ethereumjs_abi_1.default.simpleEncode("safeTransferFrom(address,address,uint256,uint256,bytes)", from, to, tokenIds[0], quantities[0], "0x00");
}
exports.modes = {
    "erc1155.transfer": erc1155Transfer,
};
//# sourceMappingURL=erc1155.js.map